import { Injectable } from '@angular/core';
import {CalendarOptions, EventInput} from '@fullcalendar/core';
import { EventImpl, VerboseFormattingArg } from '@fullcalendar/core/internal';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGrid from '@fullcalendar/resource-timegrid';
import moment from 'moment/moment';
import { EventStatusTypes } from '../enums';
import { AbstractCalendarService } from '../../../core/services/AbstractCalendarService';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SwapAuditoriumCalendarService extends AbstractCalendarService {

  public readonly calendarOptions: CalendarOptions = {
      plugins: [resourceTimeGrid, interactionPlugin],
      initialView: 'timeGridSevenDays',
      allDaySlot: false,
      datesAboveResources: true,
      schedulerLicenseKey: environment.fullcalendarLicenseKey,
      headerToolbar: false,
      footerToolbar: false,
      slotDuration: '00:05:00',
      slotLabelFormat: (arg: VerboseFormattingArg) => moment(arg.start).format('HH:mm'),
      slotMinTime: '08:00:00',
      slotMaxTime: '32:00:00',
      slotLabelInterval: { hours: 1 },
      editable: false,
      selectable: false,
      locale: this.locales[this.languageStoreService.language.token].default,
      views: {
          timeGridSevenDays: {
              type: 'resourceTimeGrid',
          },
      },
      visibleRange: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().add(1, 'day').format('YYYY-MM-DD')
      },
      eventDurationEditable: false,
      eventStartEditable: false,
      eventDidMount: () => {
        this.scrollToFirstEvent()
      }
  };

  protected readonly unselectElementsSelector = 'fc-timegrid-slot';

  public constructor(
  ) {
      super();
  }

  public override getSelectedEvents(statusTypes: EventStatusTypes[] = null): EventImpl[] {
      return this.fullCalendarApi?.getEvents().filter(event => (
          !event.extendedProps['loading'] &&
          event.extendedProps['isSelected'] &&
          !event.extendedProps['eventProps']?.isMarathon &&
          (statusTypes ? statusTypes.includes(event.extendedProps['eventProps']['status']) : true)
      ));
  }

  private scrollToFirstEvent(): void {
    this.fullCalendarEl.querySelector('div[id^="auditorium-swap-event-"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
